<atlas-modal (onClose)="close()" #ResourceRequestModal [headerRef]="ResourceRequestModalheader"
  [contentRef]="ResourceRequestModalcontent" [footerRef]="ResourceRequestModalfooter" [showDialogActions]="false"
  [size]="modalSize">
</atlas-modal>
<ng-template #ResourceRequestModalheader>
  <h4 id="resource-request-modal-header" class="dsp-modal-header">Submit a Request</h4>
</ng-template>
<ng-template #ResourceRequestModalcontent>
  <div class="dsp-modal-padding">
    <form novalidate [formGroup]="form" (ngSubmit)="submit()">
      <div class="row mos-o-form-row dsp-margin-none">
        <div class="columns medium-6">
          <p class="typographyStyles-label-small"></p>
          <atlas-field-select [style.--radius-xsmall]="'4px'" [options]="requestTypes" [placeholder]="'Please select'"
            [fullWidth]="true" [widthValue]="532" [clearable]="false" (valueChange)="onResourceTypeChange($event)"
            [label]="'How can we help you?'" [formControl]="form.get('type')" [required]="true"></atlas-field-select>
          <!-- <atlas-field-error *ngIf="form.get('type').hasError('required')">Please select an option</atlas-field-error>-->
          <div *ngIf="submitAttempted && form.get('type').errors?.required; then validate_template">
          </div>
          <ng-template #validate_template>
            <div class="alert alert-danger">
              Please select an option
            </div>
          </ng-template>
        </div>
      </div>
      <div class="row mos-o-form-row dsp-margin-none">
        <div class="columns medium-12 mos-o-form-input-field">
          <!-- <atlas-field [fullWidth]="true"> -->
          <atlas-field-label class="typographyStyles-label-small">Message</atlas-field-label>
          <textarea maxlength="3000" style="border: 3px solid #F4F4F4 !important; height : 150px; margin: 0.5rem 0;"
            (focus)="requestMessageFocus()" [formControl]="form.get('message')" placeholder="Please enter text">
</textarea>
          <!-- </atlas-field> -->
        </div>
      </div>
    </form>
  </div>
</ng-template>
<ng-template #ResourceRequestModalfooter>
  <div id="resource-request-modal-footer" class="align-right is-collapse-child dsp-modal-footer">
    <atlas-button id="button-resource-save-request" [disabled]="isSendDisabled()"
      [style]="!isSendDisabled() ? 'strong' : 'no-fill'" (click)="submit()">Send</atlas-button>
    <atlas-button id="button-resource-cancel-request" variant="text" [style]="no-fill" [elevation]="flat"
      (click)="cancel()">Cancel</atlas-button>
  </div>
</ng-template>